import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Types, loginFailure } from './actions';
import { setRefreshToken } from '../refreshToken/actions';
import loginUser, {
  generateAuthorizationCode,
  generateAccessToken,
} from '~/helpers/api/login';
import { setAxiosHeader } from '~/helpers/setAxiosHeader';
import { sensedia } from '~/config/constants';
import { getIssuer } from '~/helpers/getIssuer';
import { getEnvFromUrl } from '~/helpers/getEnv';

interface ILoadUser {
  payload: {
    email: string;
    password: string;
  };
  meta: {
    onSuccess: Function;
    onFailure: Function;
  };
}

interface ITokens {
  refresh_token: string;
  access_token: string;
}

const issuer = getIssuer();
const { isProd } = getEnvFromUrl();
const envFromUrl = isProd ? 'PROD' : 'NON_PROD';

// @ts-ignore
const { clientId, clientSecret } = sensedia[issuer][envFromUrl];
const strBase64 = btoa(`${clientId}:${clientSecret}`);

export function* login({ payload, meta }: ILoadUser) {
  const { onSuccess, onFailure } = meta;
  try {
    // Step 1
    const hash: string = yield call(generateAuthorizationCode, clientId);
    // End step 1

    // Step 2
    const payloadAccessToken = {
      hash,
      grantType: 'authorization_code',
      type: 'code',
    };

    // Headers needed in generateAccessToken
    setAxiosHeader([
      {
        name: 'client_id',
        value: clientId,
      },
      {
        name: 'Authorization',
        value: `Basic ${strBase64}`,
      },
    ]);

    const tokens: ITokens = yield call(generateAccessToken, payloadAccessToken);
    // End step 2

    yield put(setRefreshToken(tokens?.refresh_token));

    // Step 3
    // Header needed in loginUser
    setAxiosHeader([
      {
        name: 'access_token',
        value: tokens?.access_token,
      },
    ]);

    const accessToken: string = yield call(loginUser, payload);
    // End step 3

    sessionStorage.setItem('token', accessToken);

    // Header needed in bffs
    setAxiosHeader([
      {
        name: 'Authorization',
        value: accessToken,
      },
    ]);

    onSuccess();
  } catch (error) {
    yield put(loginFailure(error));
    onFailure(error);
  }
}

// @ts-ignore
export default all([takeLatest(Types.REQUEST, login)]);
